const randomString = () =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, "");


export default randomString